import React from 'react'

export interface UseHttpErrorHookResult {
  showError: (props: (HttpErrorProps & { title?: string }) | undefined) => void
  clearError: () => void
  errorProps: (HttpErrorProps & { title?: string }) | undefined
}

export interface HttpErrorProps {
  errorCode?: string
  onRefresh?: () => void
  onReportError?: () => void
}

const noError = {}

export const useHttpError = (): UseHttpErrorHookResult => {
  const [errorProps, setErrorProps] = React.useState<any>(noError)

  const showError = (props: (HttpErrorProps & { title?: string }) | undefined) => {
    setErrorProps(props)
  }
  const clearError = () => {
    setErrorProps(noError)
  }

  return { showError, clearError, errorProps }
}
